import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';

export default function Dashboard() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.getVehicles().then(v => { setVehicles(Array.isArray(v) ? v : []); setLoading(false); });
  }, []);

  const available = vehicles.filter(v => v.status === 'available');
  const pending = vehicles.filter(v => v.status === 'pending');
  const sold = vehicles.filter(v => v.status === 'sold');
  const value = available.reduce((s, v) => s + parseFloat(v.facebook_price || v.price || 0), 0);

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard <span>Overview</span></h1>
      </div>
      <div className="stats-grid">
        <div className="stat-card red"><div className="label">Available</div><div className="value">{available.length}</div><div className="sub">vehicles in stock</div></div>
        <div className="stat-card"><div className="label">Pending</div><div className="value">{pending.length}</div><div className="sub">awaiting finalization</div></div>
        <div className="stat-card"><div className="label">Sold</div><div className="value">{sold.length}</div><div className="sub">total sold</div></div>
        <div className="stat-card"><div className="label">Inventory Value</div><div className="value">${value.toLocaleString('en-US', { maximumFractionDigits: 0 })}</div><div className="sub">available stock</div></div>
      </div>
      <div className="page-header">
        <h1>Recent <span>Inventory</span></h1>
        <button className="btn-red" onClick={() => navigate('/inventory')}>View All</button>
      </div>
      {loading ? <div className="loading">Loading...</div> : (
        <div className="vehicle-grid">
          {vehicles.slice(0, 6).map(v => <VehicleCard key={v.id} vehicle={v} onClick={() => navigate(`/vehicles/edit/${v.id}`)} />)}
        </div>
      )}
    </div>
  );
}

function VehicleCard({ vehicle: v, onClick }) {
  return (
    <div className="vehicle-card">
      <div className="photo" onClick={onClick}>
        {v.primary_photo ? <img src={v.primary_photo} alt={`${v.year} ${v.make}`} /> : <span>🚗</span>}
      </div>
      <div className="info">
        <div className="title" onClick={onClick}>{v.year} {v.make} {v.model} {v.trim}</div>
        <div className="vin">{v.vin || 'No VIN'} · {Number(v.mileage || 0).toLocaleString()} mi</div>
        <div className="price">{v.price_display === 'call_for_price' ? 'Call for Price' : v.price_display === 'payment_only' ? (v.down_payment ? `$${Number(v.down_payment).toLocaleString()} Down` : '') : `$${Number(v.price || 0).toLocaleString()}`}</div>
        <div className="price-sub">{v.down_payment && v.price_display !== 'call_for_price' ? `$${Number(v.down_payment).toLocaleString()} down` : ''} {v.weekly_payment ? `· $${v.weekly_payment}/wk` : ''}</div>
        <div className="meta">
          <span className={`badge badge-${v.status}`}>{v.status}</span>
          <span className="badge badge-info">📷 {v.photo_count || 0}</span>
        </div>
      </div>
    </div>
  );
}
